import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import { APP_URL } from '../../../../config';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'BLOCKED_DATE_RANGE',
  entryPoint: '/blocked-date-ranges',
});

export default {
  ...triggers,
  blockDates(dispatch, getState, params) {
    dispatch({ type: 'BLOCKED_DATE_RANGE__POST_DATA' });
    const url = APP_URL + '/blocked-date-ranges/block-dates';
    return httpRequest('POST', url, params)
      .then(res => {
        dispatch({ type: 'BLOCKED_DATE_RANGE__POST_DATA_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'BLOCKED_DATE_RANGE__ERROR', payload: err });
      });
  },
  unblockDates(dispatch, getState, params) {
    dispatch({ type: 'BLOCKED_DATE_RANGE__POST_DATA' });
    const url = APP_URL + '/blocked-date-ranges/unblock-dates';
    return httpRequest('POST', url, params)
      .then(res => {
        dispatch({ type: 'BLOCKED_DATE_RANGE__POST_DATA_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'BLOCKED_DATE_RANGE__ERROR', payload: err });
      });
  }
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/blocked-date-range/triggers.js